<template>
    <div>
        <answer-header></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="blk1">
            <div class="fz32">စည္းကမ္းမ်ား: </div>
        </div>
        <div class="blk2">
            <p>
                1. Everyday can answer 5 questions
            </p>
            <p>
                2. Everyone would get random questions
            </p>
            <p>
                3. Answer correct would get 10 points
            </p>
            <p>
                4. Need to finish the answering witin 10 Second
            </p>
            <p>
                5. Pints could be redeemed to rewards
            </p>
            <p>
                6. More ppints would get more chance to win the Prize
            </p>
        </div>
        <div class="blk3">
            <div class="btn btn-block" @click="_goAnswer">ေမးခြန္းစေျဖရန္</div>
        </div>
    </div>
</template>
<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'Index',
    components: { answerHeader },
    computed: {
        ...mapState(['langMap','lang'])
    },
    created(){
        let token = this.$route.query.token;
        if(!token) localStorage.removeItem('token');
        token && localStorage.setItem('token', token);
    },
    methods: {
        _goAnswer(){
            Utils.$ajax({
                url: '?r=question/is-answered'
            }).done(res=>{
                if(res.code == 20003){
                    this.$messagebox_lang(res.msg).then(action=>{
                        location.href = 'http://www.baidu.com';
                    });
                    return;
                }else if(res.code != 0){
                    this.$messagebox_lang(res.msg).then(action=>{
                        this.$router.push('/login')
                    });
                    return;
                }
                

                if(res.data.isAnswered){
                    this.$router.push('/end');
                }else{
                    this.$router.push('/answer');
                }
            })
        }
    }
}

</script>
<style lang="scss" scoped>
    .blk2{
        margin-top: rem(50);
        p{
            margin-top: rem(16);
        }
    }
    .blk3{
        margin-top: rem(60);
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue